import { Button } from "../../utils/Utils";
import { GameVars } from "../../GameVars";
import { BoardManager } from "./BoardManager";
import { GameManager } from "../../GameManager";
import { GameConstants } from "../../GameConstants";

export class GUI extends Phaser.GameObjects.Container {

    private undoLabel: Phaser.GameObjects.Text;
    private undoButton: Button;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const pauseButton = new Button(this.scene, 60, 60 * GameVars.scaleY, "texture_atlas_1", "btn_menu", "btn_menu_hover");
        pauseButton.scaleY = GameVars.scaleY;
        pauseButton.onUp(this.onClickPause, this);
        this.add(pauseButton);

        const resetButton = new Button(this.scene, 160, 60 * GameVars.scaleY, "texture_atlas_1", "btn_reset", "btn_reset_hover");
        resetButton.scaleY = GameVars.scaleY;
        resetButton.onUp(this.onClickReset, this);
        this.add(resetButton);

        this.undoButton = new Button(this.scene, GameConstants.GAME_WIDTH - 80, 60 * GameVars.scaleY, "texture_atlas_1", "btn_step_back", "btn_step_back_hover");
        this.undoButton.scaleY = GameVars.scaleY;
        this.undoButton.onUp(this.onClickUndo, this);
        this.add(this.undoButton);

        this.undoLabel = new Phaser.GameObjects.Text(this.scene, GameConstants.GAME_WIDTH - 50, 59 * GameVars.scaleY, GameVars.undoNum.toString(), {fontFamily: "Bubblegum", fontSize: "42px", color: "#C23627"});
        this.undoLabel.setOrigin(.5);
        this.undoLabel.scaleY = GameVars.scaleY;
        this.add(this.undoLabel);
    }

    public hide(): void {

        this.scene.tweens.add({
            targets: this,
            y: -120,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 250,
        });
    }

    public show(): void {

        this.scene.tweens.add({
            targets: this,
            y: 0,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 250,
        });
    }

    private onClickPause(): void {

        if (GameVars.paused) {
            return;
        }

        BoardManager.pauseGame();
    }

    private onClickReset(): void {

        if (GameVars.paused) {
            return;
        }

        GameManager.enterBoardScene();
    }

    private onClickUndo(): void {
           
        if (GameVars.paused || GameVars.moves.length === 0 || GameVars.undoNum === 0) {
            return;
        }

        BoardManager.undo();

        if (GameVars.undoNum === 0) {
            this.undoButton.input.enabled = false;
            this.undoButton.setFrame("btn_step_back_disabled");
            this.undoButton.setFrames("btn_step_back_disabled");
            this.undoLabel.setColor("#606060");
        }

        this.undoLabel.text = GameVars.undoNum.toString();
    }
}
